export default function () {
    return {
        //
    };
}
